// DS: B16
import React from 'react';
import classnames from 'classnames';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/Check';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './UserWatchGhostButton.scss';
export var UserWatchGhostButton = function (_a) {
    var author = _a.author, className = _a.className, children = _a.children, onWatch = _a.onWatch, iconClassName = _a.iconClassName, isWatchingBack = _a.isWatchingBack, watchingClassname = _a.watchingClassname, onToggleWatchSuccess = _a.onToggleWatchSuccess;
    var _b = useWatchButton(author, author === null || author === void 0 ? void 0 : author.isWatching, isWatchingBack, false, onToggleWatchSuccess), onClick = _b.onClick, text = _b.text, isWatching = _b.isWatching, biData = _b.biData;
    return (React.createElement(GhostButton, { size: "small", variant: "approval-green", className: classnames(s['root'], isWatching && s['watching'], isWatching && watchingClassname, className), "data-hook": BiDataHook.USER_WATCH_BUTTON, biData: biData, onClick: function () {
            onClick();
            if (!isWatching) {
                onWatch && onWatch();
            }
        } },
        React.createElement(Plus, { customSizable: true, className: classnames(s['plus-icon'], iconClassName), size: IconSize.SMALL }),
        isWatching && (React.createElement(Check, { customSizable: true, className: classnames(s['check-icon'], iconClassName), size: IconSize.SMALL })),
        children || text));
};
UserWatchGhostButton.displayName = 'UserWatchGhostButton';
export default UserWatchGhostButton;
//# sourceMappingURL=UserWatchGhostButton.js.map